// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"1858572b","556":"cae034cc","881":"f28d71af"}[chunkId] + ".chunk.css";
};